import { render, staticRenderFns } from "./BCXMessengerChat.vue?vue&type=template&id=378f76c2&scoped=true"
import script from "./BCXMessengerChat.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerChat.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerChat.vue?vue&type=style&index=0&id=378f76c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378f76c2",
  null
  
)

export default component.exports